// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DoFcV","colMin":"styles_colMin__ejmAC"};